import * as types from './tasks-simple.types';
export const tasksSimplePageSelectors: types.ITaskSimplePageSelectors = {
  selectMyTasks: (state) => state.page.tasksSimple.myTasks,
  selectQis: (state) => state.page.tasksSimple.qi,
  selectWatcher: (state) => state.page.tasksSimple.watcher,
  selectIsFetched: (state) => state.page.tasksSimple.isFetched,
  selectLastCreatedTaskId: (state) => state.page.tasksSimple.lastCreatedTaskId,
};
